import $http from './http'
import config from './config'

export default {
    name: 'insurance',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    OrderDetails(UniqueID) {
        return $http.get(this.getUrl(`/InsuranceOrder/OrderDetails?UniqueID=${UniqueID}`));
    },
    getOrderList(data) {
        return $http.post(this.getUrl('/InsuranceOrder/List'), data);
    },
    OrderResolve(data) {
        return $http.post(this.getUrl(`/InsuranceOrder/OrderResolve`), data);
    },
    OrderUnLock(id){
        return $http.get(this.getUrl(`/InsuranceOrder/OrderUnLock?UniqueID=${id}`));
    },
    OrderLock(id){
        return $http.get(this.getUrl(`/InsuranceOrder/OrderLock?UniqueID=${id}`));
    },
    UpdateOrderPrice(data){
        return $http.post(this.getUrl('/InsuranceOrder/UpdateOrderPrice'),data);
    }
}



// WEBPACK FOOTER //
// ./src/apis/insuranceApis.js